import { render, staticRenderFns } from "./ReportStatisticAdminComponent.vue?vue&type=template&id=709890c9&scoped=true&"
import script from "./ReportStatisticAdminComponent.vue?vue&type=script&lang=js&"
export * from "./ReportStatisticAdminComponent.vue?vue&type=script&lang=js&"
import style0 from "./ReportStatisticAdminComponent.vue?vue&type=style&index=0&id=709890c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709890c9",
  null
  
)

export default component.exports